import React, { Fragment, useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext } from "store/AppContext";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { postAtkvaedi } from 'common/services/apiService';


const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  },
  loadingWrapper: {
    margin: theme.spacing(1),
    position: "relative"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

export default function StadfestaStep(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const {
    formState,
    kjosandiInfo,
    atkvaediOptions,
    handleBack,
    handleRestart,
    setSnackbarOpen
  } = props;
  const { kjosandi } = kjosandiInfo;
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  async function onSubmit() {
    setLoading(true);

    const { httpStatus, isError, error } = await postAtkvaedi(
      formState,
      context,
      {}
    );

    if (!isError) {
      setLoading(false);
      handleRestart();
      setSnackbarOpen(true);
    } else {
      if (httpStatus === 404) {
        setLoading(false);
        setIsError(true);
        setErrorMsg(`Búið er að loka fyrir kosningu`);
      } else {
        setLoading(false);
        setIsError(true);
        setErrorMsg(`Óvænt villa kom upp - ${error.traceId}`);
      }
    };
  }

  const TegundAtkvaedis = () => {
    const tegund = atkvaediOptions.find(
      a => a.id === formState.atkvaediTegundId
    );

    return (
      <div>
        <Typography variant="caption">Tegund atkvæðis</Typography>
        <Typography>
          <strong>{tegund.lysing}</strong>
        </Typography>
      </div>
    );
  };

  return (
    <Fragment>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justify="center"
        >
          <Grid item xs>
            <Typography variant="h5" style={{ marginBottom: "8px" }}>
              Eftirfarandi atkvæði verður skráð
            </Typography>
          </Grid>

          <Grid
            container
            item
            spacing={3}
            direction="row"
            alignItems="flex-start"
            justify="center"
          >
            <Grid item>
              <Typography variant="caption">Nafn</Typography>
              <Typography>
                <strong>{kjosandi.nafn}</strong>
              </Typography>
              <Typography variant="caption">Heimili</Typography>
              <Typography>
                <strong>{kjosandi.husheiti}</strong>
              </Typography>
              <Typography variant="caption">Kennitala</Typography>
              <Typography>
                <strong>{kjosandi.kennitala}</strong>
              </Typography>
              <Typography variant="caption">Kosning</Typography>
              <Typography>
                <strong>{context.activeKosning.get.lysing}</strong>
              </Typography>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item>
              <TegundAtkvaedis />
            </Grid>
          </Grid>

          <Grid item xs>
            {isError && (
              <div>
                <Typography color="error">
                  <strong>{errorMsg}</strong>
                </Typography>
              </div>
            )}
          </Grid>
          <Grid item xs>
            <div className={classes.loadingWrapper}>
              <Button
                color="primary"
                variant="contained"
                size="large"
                disabled={loading}
                onClick={onSubmit}
              >
                Skrá atkvæði
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid
        container
        spacing={2}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Grid item>
          <Button onClick={handleBack}>Til baka</Button>
        </Grid>
      </Grid>
    </Fragment>
  );
}
